export default __webpack_public_path__ + "static/media/icon-martini.77236472.svg";